module.exports = __webpack_public_path__ + "img/bg_resize_castle_front.af02d1e8.webp";